import React, { useMemo } from 'react';
import ScenePlayer from './ScenePlayer';

function normalizeIntro(intro) {
  const opponent = intro?.opponent || null;
  const opponentName = opponent?.name || 'Opponent';
  const comment = typeof intro?.comment === 'string' && intro.comment.trim()
    ? intro.comment.trim()
    : 'Grrr... I have been waiting for this battle.';
  const imagePrefix = opponent?.type === 'human' ? 'player' : 'monster';

  return {
    opponent,
    comment,
    phaseLabel: intro?.phaseLabel || 'Tournament Battle',
    dayIndex: intro?.dayIndex || null,
    fallbackFrame: {
      name: opponentName,
      text: comment,
      image: opponent?.imageId ? `${imagePrefix}.${opponent.imageId}` : '',
    },
  };
}

function TournamentOpponentIntro({ intro, onContinue }) {
  const normalizedIntro = useMemo(() => normalizeIntro(intro), [intro]);
  const scene = intro?.scene || null;
  const meta = (
    <>
      <span>{normalizedIntro.phaseLabel}</span>
      {normalizedIntro.dayIndex && <span>Day {normalizedIntro.dayIndex}</span>}
    </>
  );

  return (
    <ScenePlayer
      scene={scene}
      fallbackFrame={normalizedIntro.fallbackFrame}
      onContinue={onContinue}
      variant="opponent"
      continueLabel="Enter Battle Practice"
      nextLabel="Next"
      meta={meta}
      showVs
      messageTestId="opponent-intro-message"
    />
  );
}

export default TournamentOpponentIntro;
